/**
 * Represents an option with a label and a value with number type by default.
 * @template T The type of the value.
 */
export interface IOption<T = number> {
  label: string;
  value: T;
}
